import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from './components/datatable/datatable.component';
import { ChassisDatatableModule } from '@kaiser-software/chassis-datatable';

@NgModule({
    imports: [
        CommonModule,
        ChassisDatatableModule.forRoot()
    ],
    declarations: [
        DatatableComponent,
    ],
    entryComponents: [
        DatatableComponent
    ],
    exports: [
        DatatableComponent
    ],
})
export class ChassisNovaModule {
}



// WEBPACK FOOTER //
// ./libs/chassis-nova/src/chassis-nova.module.ts